// import './nouislider.min.js';
// import './nouislider.css';
import './archive-filter.scss';

function isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export default () => {
    // Open/close filter
    document.body.addEventListener('click', function(e) {
        if (e.target.closest('.toggle-filter .toggle-filter-button')) {
            e.preventDefault();

            var filter = document.querySelector('.archive-filter');
            if (filter) {
                if (filter.classList.contains('active')) {
                    filter.classList.remove('active');
                } else {
                    filter.classList.add('active');
                }
            }
        }
    });

    var filterToggle = document.querySelector('.filter-mobile-toggle');
    if (filterToggle) {
        filterToggle.addEventListener('click', function () {
            this.parentElement.querySelector('.all-filters-holder').classList.toggle('hidden');
        });
    }

    function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            }, wait);
            if (immediate && !timeout) func.apply(context, args);
        };
    }

    // Filter
    function toggleLoader(el) {
        if (el) {
            el.classList.toggle('loader-active');
        }
    }

    // Filter
    function extractFilterData() {
        // Find the div with the lef-current-page-filter-data attribute
        const filterDiv = document.querySelector('[lef-current-page-filter-data]');
        let filterData = [];

        if (filterDiv) {
            // Get the value of the lef-current-page-filter-data attribute
            const filterDataString = filterDiv.getAttribute('lef-current-page-filter-data');

            // Parse the JSON string to an object
            try {
                filterData = JSON.parse(filterDataString.replace(/&quot;/g, '"'));
            } catch (error) {
                console.error('Error parsing filter data:', error);
            }
        } else {
            console.log('No filter data found.');
        }

        return filterData;
    }

    function extractUrlData() {
        // Get URL query parameters
        const params = new URLSearchParams(window.location.search);
        let getData = {};
    
        params.forEach((value, key) => {
            const newKey = key.startsWith('f_') ? key.substring(2) : key;
            
            // Split value by commas and store it in the array
            const values = value.split(',').map(val => val.trim()); // Split by comma and trim any extra spaces
            
            // Add all values to the array under the corresponding key
            if (getData[newKey]) {
                getData[newKey] = getData[newKey].concat(values); // Concatenate new values
            } else {
                getData[newKey] = values; // Initialize with the split values
            }
        });
    
        return getData;
    }

    function collectSelectedData(extraData = {}) {
        let selectedData = {};
        let possibleFilters = {};
        let currentPageFilterData = extractFilterData();

        // Collect all checkboxes and selects with the data-lef-filter attribute
        document.querySelectorAll('[data-lef-filter]').forEach(function(element) {
            const filterValue = element.getAttribute('data-lef-filter');
            const elementValue = element.type === 'checkbox' ? element.value : element.value;

            // track what can be filtered
            if (!possibleFilters[filterValue]) {
                possibleFilters[filterValue] = [];
            }

            // If it's a checkbox and it's selected
            if (element.type === 'checkbox') {
                if (element.checked) {
                    // Initialize the key in selectedData if not already present
                    if (!selectedData[filterValue]) {
                        selectedData[filterValue] = [];
                    }
                    selectedData[filterValue].push(elementValue); // Add value to the array
                }
            } else if (element.tagName === 'SELECT' || element.tagName === 'INPUT') {
                // If it's a select, get the selected value
                const selectedOption = element.value;
                if (selectedOption) {
                    // Initialize the key in selectedData if not already present
                    if (!selectedData[filterValue]) {
                        selectedData[filterValue] = [];
                    }
                    selectedData[filterValue].push(selectedOption); // Add value to the array
                }
            }
        });

        // extra filter options
        if (extraData && extraData.clicked && extraData.clicked == 'reset_filter') {
            if (currentPageFilterData && currentPageFilterData.main) {
                console.warn(currentPageFilterData.main);
                selectedData = currentPageFilterData.main; // reset back to page main
            } else {
                selectedData = {};
            }
        } 

        var urlData = extractUrlData();
        // remove GET data from old url's if not actualy in the filter anymore except if its not a filterable item by default
        // Object.keys(urlData).forEach(key => {
        //     if (possibleFilters.hasOwnProperty(key) && !selectedData.hasOwnProperty(key)) {
        //         delete urlData[key];
        //     }
        // });
        // Object.keys(currentPageFilterData['combined']).forEach(key => {
        //     if (possibleFilters.hasOwnProperty(key) && !selectedData.hasOwnProperty(key)) {
        //         delete currentPageFilterData['combined'][key];
        //     }
        // });

        // Log the final selected data
        const payload = {
            filter_data: selectedData, // all from filter
            page_data: currentPageFilterData, // all found on page
            get_data: urlData, //for new get data
            go_to_page: extraData && extraData.pageNr ? extraData.pageNr : '',
            possible_filters: possibleFilters,
        };
        var formData = new FormData();
        toggleLoader(document.querySelector('[lef-current-page-filter-data]'));
        toggleLoader(document.querySelector('[data-lef-filter-loop]'));

        formData.append( 'action', 'lef_filter_archive_action' );
        formData.append( 'payload', JSON.stringify(payload) );
        fetch(theme_object.ajax_url, {
            method: 'POST',
            body: formData,
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                if(typeof data.data.loop != 'undefined') {
                    var redirecting = false;
                    if(typeof data.data.redirect_url !== 'undefined' && data.data.redirect_url !== '') {
                        // Redirect to the URL
                        const currentUrlBase = window.location.origin + window.location.pathname;
                        const redirectUrlBase = new URL(data.data.redirect_url).origin + new URL(data.data.redirect_url).pathname;
                        if (currentUrlBase !== redirectUrlBase && data.data.prevent_redirect != true) {
                            window.location.href = data.data.redirect_url;
                            redirecting = true;
                        } else {
                            const newUrl = data.data.redirect_url; // Get the full URL including query parameters
                            history.pushState({ path: newUrl }, '', newUrl); // Push the new URL to the history state
                        }
                    }

                    if (redirecting == false) {
                        var loopItem = false;
                        document.querySelectorAll('[data-lef-filter-loop]').forEach(element => {
                            element.outerHTML = data.data.loop; // Replaces the entire element
                            loopItem = element;
                        });
                        
                        if(typeof extraData.pageNr != 'undefined') {
                            document.querySelector('[data-lef-filter-loop]').scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }
    
                        if(typeof data.data.filter != 'undefined') {
                            document.querySelectorAll('[data-lef-filter-filter]').forEach(element => {
                                element.innerHTML = data.data.filter; // Or use another method depending on the requirement
                            });
                        }
    
                        //re-dispatch dom content loaded for proper componentloading
                        window.document.dispatchEvent(new Event("DOMContentLoaded", {
                            bubbles: true,
                            cancelable: true
                        }));
                    }
                }
            } else {
                console.error('Error in AJAX response:', data);
            }
        })
        .catch(error => {
            console.error('Fetch error:', error);
            toggleLoader(document.querySelector('[lef-current-page-filter-data]'));
            toggleLoader(document.querySelector('[data-lef-filter-loop]'));
            alert('A error occured please refresh the page');
        });
    }

    document.addEventListener('change', function (event) {
        if (event.target.matches('[data-lef-filter]')) {
            collectSelectedData();
        }
    });

    document.addEventListener('click', function (event) {
        if (event.target.type == "button" && event.target.matches('[data-lef-filter]')) {
            var extraData = {clicked: event.target.getAttribute('data-lef-filter')}
            collectSelectedData(extraData);
        }
    });

    document.addEventListener('click', function (event) {
        if (event.target.matches('[data-page]')) {
            event.preventDefault();
            var extraData = {pageNr: event.target.getAttribute('data-page')}
            collectSelectedData(extraData);
        }
    });

    //! old filtering

    // var is_page_load = true;

    // if (document.querySelector('#archive-list')) {
    //     var filterBox = document.querySelector('.archive-filter');
    //     var currentPageUrl = filterBox.getAttribute('data-current-page');
    //     var firstInit = false;

    //     function toggleLoader(el) {
    //         if (el) { // Check if the element exists
    //             el.classList.toggle('loader-active');
    //         }
    //     }

    //     function toggleButton(el, action) {
    //         if (el) { // Check if the element exists
    //             if (el.classList.contains('hide')) {
    //                 el.classList.remove('hide'); // Remove the initial hiding class
    //             }
        
    //             if (action === 'show') {
    //                 el.style.display = 'block';
    //             } else if (action === 'hide') {
    //                 el.style.display = 'none';
    //             } else {
    //                 el.style.display = el.style.display === 'none' ? 'block' : 'none';
    //             }
    //         }
    //     }

    //     var parameterCache = window.location.search.substring(1);

    //     function getUrlParameter(sParam) {
    //         if (sParam === 'page') {
    //             const pathSegments = window.location.pathname.split('/').filter(Boolean);
    //             const pageIndex = pathSegments.indexOf('page');
    //             return pageIndex !== -1 ? pathSegments[pageIndex + 1] || 1 : 1;
    //         }
    //         // Existing logic for other parameters
    //         var sPageURL = parameterCache,
    //             sURLVariables = sPageURL.split('&'),
    //             sParameterName;
        
    //         for (var i = 0; i < sURLVariables.length; i++) {
    //             sParameterName = sURLVariables[i].split('=');
    //             if (sParameterName[0] === sParam) {
    //                 return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    //             }
    //         }
    //     }        

    //     function setUrlParameter(key, value) {
    //         key = encodeURIComponent(key);
    //         // Encode value but leave commas unencoded
    //         value = encodeURIComponent(value).replace(/%2C/g, ',');
        
    //         var kvp = parameterCache.split('&');
    //         var i = kvp.length;
    //         var x;
        
    //         if (value !== '') {
    //             while (i--) {
    //                 x = kvp[i].split('=');
    //                 if (x[0] === key) {
    //                     x[1] = value;
    //                     if (value !== '' || value.length !== 0) {
    //                         kvp[i] = x.join('=');
    //                     } else {
    //                         kvp.splice(i, 1);
    //                     }
    //                     break;
    //                 }
    //             }
    //             if (i < 0) {
    //                 kvp[kvp.length] = [key, value].join('=');
    //             }
    //         } else {
    //             while (i--) {
    //                 x = kvp[i].split('=');
    //                 if (x[0] === key) {
    //                     kvp.splice(i, 1);
    //                 }
    //             }
    //         }
    //         kvp = kvp.filter(Boolean);
    //         return kvp.join('&');
    //     }

    //     var pagedFromUrl = getUrlParameter('page') !== undefined ? getUrlParameter('page') : 1;
    //     var filterFromUrl = getUrlParameter('filter');
    //     var PriceMaxFromUrl = getUrlParameter('max_prijs');
    //     var PriceMinFromUrl = getUrlParameter('min_prijs');
    //     var searchFromUrl = getUrlParameter('zoeken');
    //     var sortFromUrl = getUrlParameter('sorteren');

    //     if (is_page_load) {
    //         var archive_list = document.querySelector('#archive-list');
    //         if (archive_list) {
    //             var archive_tax = archive_list.getAttribute('data-tax');
    //             var archive_term = archive_list.getAttribute('data-term');

    //             if (archive_tax != undefined && archive_tax != '' && archive_term != undefined && archive_term != '') {
    //                 if (document.querySelector('input[value="' + archive_term + '"]')) {
    //                     document.querySelector('input[value="' + archive_term + '"]').checked = true;
    //                 }
    //             }
    //         }
    //     }

    //     function ajax_load_more(container, button, post_type, section, current_posts, replace, show_page = pagedFromUrl) {
    //         var filter = [];

    //         var archiveList = document.querySelector('#archive-list');
    //         var button = archiveList.querySelector('a.load-more-posts');
    //         var container = archiveList.querySelector('.post-container');
    //         var post_type = archiveList.getAttribute('data-type');
    //         var tax = archiveList.getAttribute('data-tax');
    //         var items_per_row = archiveList.getAttribute('data-items-per-row');
    //         if (items_per_row == null || items_per_row == undefined || items_per_row == '') {
    //             items_per_row = 3;
    //         }

    //         // Handling the filters from the URL
    //         if (is_page_load && typeof filterFromUrl !== "undefined" && filterFromUrl.length) {
    //             if (typeof filterFromUrl !== 'string') {
    //                 filterFromUrl = String(filterFromUrl); // Convert to string if it's not already
    //             }
                
    //             filterFromUrl = filterFromUrl.split(',');
                
    //             filterFromUrl.forEach(function(f) {
    //                 if (!filter.includes(f)) filter.push(f);
    //             });
    //         }

    //         // Get all checked checkboxes with 'input.filter:checked'
    //         var checkedInputs = section != null && section.querySelectorAll('input.filter') ? section.querySelectorAll('input.filter') : false;
    //         var selectedOptions = section != null && section.querySelectorAll('select:not([name="sort"]) option') ? section.querySelectorAll('select:not([name="sort"]) option') : false;

    //         if (checkedInputs.length || selectedOptions.length) {
    //             checkedInputs.forEach(function(input) {
    //             if (input.checked && !filter.includes(input.value)) {
    //                 filter.push(input.value);
    //             }
    //             });
            
    //             // Get all selected options with 'option:selected'
    //             selectedOptions.forEach(function(option) {
    //             if (option.selected && option.value !== "" && !filter.includes(option.value)) {
    //                 filter.push(option.value);
    //             }
    //             });
    //         } else {
    //             var term = archiveList.getAttribute('data-term');
    //             if (typeof term !== 'undefined' && term !== "" && !filter.includes(term)) {
    //                 filter.push(term);
    //             }
    //         }

    //         var paged = show_page !== pagedFromUrl ? show_page : pagedFromUrl;

    //         // Get price min and max
    //         if (section != null && section.querySelector('.price-filter')) {
    //             var priceMin = 0;
    //             var priceMax = 0;
    
    //             if (is_page_load) {
    //                 if (PriceMinFromUrl != undefined && PriceMinFromUrl.length) {
    //                     priceMin = PriceMinFromUrl;
    //                 }
    //                 if (PriceMaxFromUrl != undefined && PriceMaxFromUrl.length) {
    //                     priceMax = PriceMaxFromUrl;
    //                 }
    //             }
    
    //             if (priceMax == 0) {
    //                 var priceMaxField = section.querySelector('#price_max');
    //                 if (priceMaxField && priceMaxField.value !== "") priceMax = priceMaxField.value;
    //             }
    //         }           

    //         toggleLoader(container);
    //         toggleLoader(filterBox);
    //         toggleLoader(document.querySelector('.ajax-pagination'));
    //         toggleButton(button, 'hide');

    //         if (replace) current_posts = 0;

    //         if (is_page_load) {
    //             if (sortFromUrl != undefined && sortFromUrl != 'undefined' && sortFromUrl != '') {
    //                 order = sortFromUrl;
    //             } else {
    //                 order = '';
    //             }
    //         } else {
    //             var order = section != null && section.querySelector('#filter-sort') ? section.querySelector('#filter-sort') : '';
    //             order = order ? order.value : '';
    //         }

    //         if (is_page_load) {
    //             if (searchFromUrl != undefined && searchFromUrl != 'undefined' && searchFromUrl != '') {
    //                 search = searchFromUrl;
    //             } else {
    //                 search = '';
    //             }
    //         } else {
    //             var search = document.querySelector('.filter-buttons #searchform input');
    //             search = search ? search.value : '';
    //         }

    //         var ajax_data = {
    //             action: 'lef_do_archive_filter',
    //             post_type: post_type,
    //             count: current_posts,
    //             filter: filter,
    //             search: search,
    //             order: order,
    //             tax: tax,
    //             term: term,
    //             security: theme_object.ajaxnonce,
    //             paged: paged,
    //             items_per_row: items_per_row,
    //             current_page_url: currentPageUrl,
    //         };

    //         if (priceMin != undefined) {
    //             ajax_data['price_min'] = priceMin;
    //         }
    //         if (priceMax != undefined) {
    //             ajax_data['price_max'] = priceMax;
    //         }

    //         var xhr = new XMLHttpRequest();
    //         xhr.open('POST', theme_object.ajax_url, true);
    //         xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    //         // Prepare the data
    //         var params = new URLSearchParams(ajax_data).toString();

    //         // Success callback
    //         xhr.onreadystatechange = function () {
    //             if (xhr.readyState === 4) {
    //                 if (xhr.status >= 200 && xhr.status < 400) {
    //                     var data = xhr.responseText;

    //                     if (isJson(data)) {
    //                         data = JSON.parse(data);
    //                         if (data.html != undefined && data.html != '') {
    //                             if (replace) {
    //                                 container.innerHTML = data.html;
    //                                 if (document.querySelector('.ajax-pagination')) {
    //                                     document.querySelector('.ajax-pagination').innerHTML = data.pagination;
    //                                 }
    //                             } else {
    //                                 container.insertAdjacentHTML('beforeend', data.html);
    //                                 if (document.querySelector('.ajax-pagination')) {
    //                                     document.querySelector('.ajax-pagination').innerHTML = data.pagination;
    //                                 }                            
    //                             }
    //                         } else {
    //                             if (data.term_link == undefined || data.term_link == '') {
    //                                 if (replace) {
    //                                     container.innerHTML = '<div class="column"><p>' + theme_object.messages.ajax_filter_no_results_found + '</p></div>';
    //                                 } else {
    //                                     container.insertAdjacentHTML('beforeend', '<div class="column"><p>' + theme_object.messages.ajax_filter_no_results_found + '</p></div>');
    //                                 }
    //                             }
    //                         }
    //                     } else {
    //                         container.insertAdjacentHTML('beforeend', '<div class="column"><p>' + theme_object.messages.ajax_filter_no_results_found + '</p></div>');
    //                     }
                                                
    //                     if (data.term_link == undefined || data.term_link == '') {
    //                         parameterCache = setUrlParameter('filter', ajax_data.filter);
    //                     } else {
    //                         parameterCache = setUrlParameter('filter', '');
    //                     }

    //                     if (ajax_data.price_min != undefined) {
    //                         parameterCache = setUrlParameter('min_prijs', ajax_data.price_min);
    //                     }
    //                     if (ajax_data.price_max != undefined) {
    //                         parameterCache = setUrlParameter('max_prijs', ajax_data.price_max);
    //                     }
    //                     parameterCache = setUrlParameter('zoeken', ajax_data.search);
    //                     parameterCache = setUrlParameter('sorteren', ajax_data.order);

    //                     if (data.term_link != undefined && data.term_link != '') {
    //                         if (data.term_link.includes('?')) {
    //                             parameterCache = parameterCache ? '&' + parameterCache : '';
    //                         } else {
    //                             parameterCache = parameterCache ? '?' + parameterCache : '';
    //                         }
    //                         window.location.replace(data.term_link + parameterCache);
    //                     } else {
    //                         document.getElementById("archive-list").scrollIntoView({ behavior: "smooth" });

    //                         window.history.pushState(
    //                             "filter",
    //                             "filtered",
    //                             ajax_data.paged > 1
    //                                 ? `${window.location.pathname.replace(/\/page\/\d+/, '')}page/${ajax_data.paged}/${parameterCache ? '?' + parameterCache : ''}`
    //                                 : `${window.location.pathname.replace(/\/page\/\d+/, '')}${parameterCache ? '?' + parameterCache : ''}`
    //                         );

    //                         toggleLoader(container);
    //                         toggleLoader(filterBox);
    //                         toggleLoader(document.querySelector('.ajax-pagination'));

    //                         current_posts = container.querySelectorAll('.card').length;
    //                         if (data.count && current_posts < data.count) {
    //                             toggleButton(button, 'show');
    //                         }
    //                     }

    //                     document.dispatchEvent(new Event('leflite_ajax_load_more_succeeded', { bubbles: true }));
    //                 }
    //             }
    //         };

    //         // Error callback
    //         xhr.onerror = function() {
    //             container.insertAdjacentHTML('beforeend', '<div class="column"><p>' + theme_object.messages.ajax_filter_loading_failed + '</p></div>');
    //             document.dispatchEvent(new Event('leflite_ajax_load_more_failed', { bubbles: true }));
    //         };

    //         // Send the request
    //         xhr.send(params);
    //     }

    //     function prepare_and_do_filter(find_current_post = false, element, replace = true, page = getUrlParameter('pagina')) {
    //         var section = element.closest('.archive-filter');
    //         var archiveList = document.querySelector('#archive-list');
    //         var button = archiveList.querySelector('a.load-more-posts');
    //         var container = archiveList.querySelector('.post-container');
    //         var post_type = archiveList.getAttribute('data-type');

    //         var current_posts = find_current_post ? container.querySelectorAll('.card').length : 0;

    //         ajax_load_more(container, button, post_type, section, current_posts, replace, page);
    //     }

    //     document.querySelectorAll('.filter-list input[type="checkbox"]').forEach(function (checkbox) {
    //         checkbox.addEventListener('change', debounce(function () {
    //             prepare_and_do_filter(false, this);
    //         }, 50));
    //     });

    //     document.querySelectorAll('.filter-list input[type="date"]').forEach(function (dateInput) {
    //         dateInput.addEventListener('change', debounce(function () {
    //             prepare_and_do_filter(false, this);
    //         }, 50));
    //     });

    //     document.querySelectorAll('.filter-list select').forEach(function (select) {
    //         select.addEventListener('change', debounce(function () {
    //             prepare_and_do_filter(false, this);
    //         }, 50));
    //     });

    //     var search_input = document.querySelector('.filter-buttons #searchform input');
    //     if (search_input) {
    //         document.querySelector('.filter-buttons #searchform input').addEventListener('input', debounce(function () {
    //             prepare_and_do_filter(false, this);
    //         }, 500));
    //     }
        
    //     document.querySelector('#archive-list').addEventListener('click', function (e) {
    //         if (e.target.classList.contains('load-more-posts')) {
    //             e.preventDefault();
    //             prepare_and_do_filter(true, e.target, false);
    //         }
    //     });

    //     document.querySelectorAll('.price-filter .price-slider-values input').forEach(function (input) {
    //         input.addEventListener('change', debounce(function () {
    //             prepare_and_do_filter(false, this);
    //         }, 50));
    //     });

    //     document.addEventListener('click', function (e) {
    //         const pagination = document.querySelector('.ajax-pagination');
    //         const target = e.target; // Directly using the clicked element
        
    //         if (pagination && pagination.contains(target) && target.hasAttribute('data-page')) {
    //             e.preventDefault();

    //             var new_page = target.getAttribute('data-page');
    //             document.querySelector('.ajax-pagination li.active').classList.remove('active');
    //             document.querySelector('.ajax-pagination li[data-page="' + new_page + '"]').classList.add('active');
                
    //             var archive_filter = document.querySelector('.archive-filter');
    //             if (archive_filter == null) {
    //                 archive_filter = document.querySelector('[data-component="archive-filter"]');
    //             }
    //             prepare_and_do_filter(true, archive_filter, true, new_page);
    //         }
    //     });

    //     document.querySelectorAll('.filter-list div').forEach(function (div) {
    //         div.addEventListener('click', function () {
    //             var checkbox = this.querySelector('input.filter');
    //         });
    //     });

    //     document.body.addEventListener('click', function (e) {
    //         if (e.target.classList.contains('reset-filter')) {
    //             e.preventDefault();
    //             document.querySelectorAll('.filter-list input[type="checkbox"]:checked').forEach(function (checkbox) {
    //                 checkbox.click();
    //             });
    //             document.querySelectorAll('.filter-list select').forEach(function (select) {
    //                 const noneOption = select.querySelector('option[value="none"]');
    
    //                 if (noneOption) {
    //                     select.value = 'none';
    //                 } else {
    //                     select.selectedIndex = 0; // Select the first option
    //                 }
    //             });
    //             document.querySelectorAll('.filter-list input').forEach(function (input) {
    //                 if (input.getAttribute('data-price-min')) {
    //                     input.value = input.getAttribute('data-price-min');
    //                 } else if (input.getAttribute('data-price-max')) {
    //                     input.value = input.getAttribute('data-price-max');
    //                 } else {
    //                     input.value = '';
    //                 }
    //             });
    //             prepare_and_do_filter(false, document.querySelector('.archive-filter'));
    //         }
    //     });

    //     if (!is_page_load) {
    //         prepare_and_do_filter(false, document.querySelector('.archive-filter'));
    //     } else {
    //         is_page_load = false;
    //     }
    // }

    // price slider init
    // var priceSlider = document.getElementById('price-slider');
    // var priceSliderMin = document.getElementById('price_min');
    // var priceSliderMax = document.getElementById('price_max');

    // if (priceSlider) {
    //     var startNr = Number(priceSliderMin.getAttribute('data-price-min') != '' ? priceSliderMin.getAttribute('data-price-min') : 0);
    //     var endNr = Number(priceSliderMax.getAttribute('data-price-max') != '' ? priceSliderMax.getAttribute('data-price-max') : Number(priceSliderMax.getAttribute('data-price-max')));

    //     if (isNaN(endNr) && isNaN(parseFloat(endNr))) {
    //         endNr = 100000;
    //     }

    //     // create price slider
    //     noUiSlider.create(priceSlider, {
    //         start: [startNr, endNr],
    //         connect: true,
    //         range: {
    //             'min': [Number(priceSliderMin.getAttribute('data-price-min'))],
    //             'max': [Number(priceSliderMax.getAttribute('data-price-max'))]
    //         }
    //     });

    //     // update selected values
    //     priceSlider.noUiSlider.on('update', function (values) {
    //     if (priceSliderMin) {
    //         priceSliderMin.value = Math.round(values[0]);
    //     }
    //     if (priceSliderMax) {
    //         priceSliderMax.value = Math.round(values[1]);
    //     }
    //     });

    //     // add change event to slider min and slider max labels to execute AJAX
    //     priceSlider.noUiSlider.on('change', function (values) {
    //         var evt = document.createEvent("HTMLEvents");
    //         evt.initEvent("change", false, true);
    //         priceSliderMin.dispatchEvent(evt);
    //         priceSliderMax.dispatchEvent(evt);
    //     });

    // }
}